var map = {
	"./dark/firma_henry_ford_white.png": 9709,
	"./dark/firma_leonardo_white.png": 1514,
	"./dark/firma_mah_white.png": 7315,
	"./dark/firma_michael_jordan_white.png": 1826,
	"./dark/firma_nelson_mandela_white.png": 4285,
	"./dark/logo_cadimun_white.png": 8081,
	"./dark/logo_lasevi_white.png": 1050,
	"./dark/logo_mediateca_white.png": 9707,
	"./dark/logo_monte_white.png": 5763,
	"./dark/logo_registra_white.png": 9540,
	"./dark/logo_sanar_white.png": 2733,
	"./dark/logo_softgreen_white.png": 9605,
	"./dark/mapa_proyectos_white.png": 1754,
	"./firma_henry_ford.png": 9358,
	"./firma_leonardo.png": 6452,
	"./firma_mah.png": 771,
	"./firma_michael_jordan.png": 2302,
	"./firma_nelson_mandela.png": 6591,
	"./logo_agroguachal.png": 1162,
	"./logo_aguas.png": 3240,
	"./logo_alcaldia_manizales.png": 4665,
	"./logo_alcaldia_manizales_white.png": 6824,
	"./logo_alcaldia_neira.png": 2626,
	"./logo_alcaldia_riosucio.png": 9007,
	"./logo_angiohealth.png": 3360,
	"./logo_cadimun.png": 833,
	"./logo_cide.png": 7869,
	"./logo_cide_black.png": 6832,
	"./logo_cide_skyblue.png": 8605,
	"./logo_cide_white.png": 2089,
	"./logo_codechoco.png": 6405,
	"./logo_datarenta.png": 8034,
	"./logo_fenalco.png": 6363,
	"./logo_funec.png": 6684,
	"./logo_gobernacion_caldas.png": 1298,
	"./logo_huella_ambiental.png": 4617,
	"./logo_infi.png": 4898,
	"./logo_invensa.png": 443,
	"./logo_lasevi.png": 9928,
	"./logo_mediateca.png": 6953,
	"./logo_monte.png": 326,
	"./logo_palestina.png": 1397,
	"./logo_people_contact.png": 2149,
	"./logo_registra.png": 6898,
	"./logo_sanar.png": 8305,
	"./logo_softgreen.png": 5004,
	"./logo_sps.png": 6848,
	"./logo_viterbo.png": 2301,
	"./mapa_proyectos.png": 9191,
	"./poster_lasevi.png": 3738,
	"./poster_mediateca.png": 1968,
	"./role_argemiro.png": 3969,
	"./role_danny.png": 3084,
	"./role_julian.png": 8917,
	"./role_salome.png": 949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;